import React, { useState, useEffect, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './works.css';

export default function Appnoticia() {
  const [index, setIndex] = useState(0);
  const [hovered, setHovered] = useState(null);
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  const NoticiaData = [
    {
      id: 1,
      link: '/noticia/1',
      image: require('../../assets/Not_14.jpg'),
      title: 'CURSO PREPARATÓRIO ISPA para acesso Ano Lectivo 2025-2026',
      subtitle: 'Acredite no seu potencial e nunca desista. O sucesso é o resultado de um esforço constante.'
    },
    {
      id: 2,
      link: '/noticia/2',
      image: require('../../assets/Not_15_Capa.jpg'),
      title: 'Brasil e Angola unidos por laços espirituais e acadêmicos',
      subtitle: 'ISPA Atlântida e Instituto Azusa fortalecem laços acadêmicos e espirituais em encontro histórico.'
    },
    {
      id: 3,
      link: '/noticia/3',
      image: require('../../assets/Not_17.jpg'),
      title: 'Visita da Secretária de Estado para a Ciência, Tecnologia e Inovação,',
      subtitle: 'O objetivo da visita foi conhecer as atividades científicas da instituição, identificar pontos fortes e áreas de melhoria, encorajar investigadores ...'
    },
    {
      id: 4,
      link: '/noticia/4',
      image: require('../../assets/Not_01.jpg'),
      title: 'Jornadas Académicas 2025',
      subtitle: 'Participe das Jornadas Académicas 2025 e amplie seus horizontes acadêmicos e profissionais.'
    },
    {
      id: 5,
      link: '/noticia/5',
      image: require('../../assets/Not_02.jpg'),
      title: 'Inscrições Abertas',
      subtitle: 'Garanta sua vaga no próximo ano letivo com condições especiais de matrícula.'
    },
    {
      id: 6,
      link: '/noticia/6',
      image: require('../../assets/Not_03.jpg'),
      title: 'Explore o Conhecimento com o ISPA',
      subtitle: 'Venha descobrir um mundo de oportunidades acadêmicas.'
    }
  ];

  const chunkArray = (arr, size) =>
    arr.reduce((acc, _, i) => {
      if (i % size === 0) acc.push(arr.slice(i, i + size));
      return acc;
    }, []);

  const groupedSlides = chunkArray(NoticiaData, 3);

  const styles = {
    noticiaCard: {
      backgroundColor: '#fff',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
      transition: 'all 0.3s ease-in-out',
      height: '100%',
      textDecoration: 'none',
    },
    noticiaCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    },
    noticiaImage: {
      width: '100%',
      height: '200px',
      objectFit: 'cover',
    },
    noticiaLabel: {
      padding: '15px',
      color: '#333',
    },
    noticiaLabelH5: {
      fontSize: '1.1rem',
      marginBottom: '10px',
      fontWeight: 600,
      color: '#00761f',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
    },
    noticiaLabelP: {
      fontSize: '0.95rem',
      color: '#555',
    },
    arrow: {
      position: 'absolute',
      top: '50%',
      zIndex: 10,
      transform: 'translateY(-50%)',
      fontSize: '2rem',
      background: 'rgba(255, 255, 255, 0.85)',
      padding: '8px',
      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    arrowLeft: { left: '-30px' },
    arrowRight: { right: '-30px' },
    carouselWrapper: { position: 'relative' },
  };

  const fadeDown = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0 },
  };

  const fadeMiddle = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0 },
  };

  const handleSelect = (selectedIndex) => setIndex(selectedIndex);
  const goPrev = () => setIndex((prev) => (prev === 0 ? groupedSlides.length - 1 : prev - 1));
  const goNext = () => setIndex((prev) => (prev === groupedSlides.length - 1 ? 0 : prev + 1));

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev === groupedSlides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [groupedSlides.length]);

  // Atualizado: IntersectionObserver responsivo
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      {
        threshold: 0.1,
        rootMargin: '0px 0px -20% 0px',
      }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.section
      ref={sectionRef}
      id="works"
      className="block works-block"
      initial={{ opacity: 0, y: 100 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
      transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      <Container fluid>
      <motion.div
        className="title-holder-modern py-5 px-3 px-md-4"
        style={{
          textAlign: 'left',
          marginBottom: '2.5rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '-100px',
          marginLeft: '20px',
        }}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        transition={{ duration: 0.7 }}
        variants={fadeDown}
      >
        <h2
          className="section-title"
          style={{
            color: '#00761F',
            fontWeight: '700',
            fontSize: '2.5rem',
            textTransform: 'uppercase',
            marginBottom: '14px'
          }}
        >
          Notícias em Destaque
        </h2>
        <div
          className="section-subtitle"
          style={{
            fontWeight: '500',
            color: '#444',
            fontSize: '1.25rem',
            letterSpacing: '0.5px'
          }}
        >
          Fique por dentro das notícias mais recentes e relevantes
        </div>
        <div
          className="section-underline"
          style={{
            marginTop: '20px',
            width: '60px',
            height: '4px',
            backgroundColor: '#00761F',
            borderRadius: '2px'
          }}
        ></div>
      </motion.div>


        <div style={styles.carouselWrapper}>
          <FaChevronLeft
            style={{ ...styles.arrow, ...styles.arrowLeft }}
            onClick={goPrev}
            title="Anterior"
          />
          <FaChevronRight
            style={{ ...styles.arrow, ...styles.arrowRight }}
            onClick={goNext}
            title="Próxima"
          />
          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            controls={false}
            indicators={false}
            interval={null}
            fade
          >
            {groupedSlides.map((group, slideIndex) => (
              <Carousel.Item key={slideIndex}>
                <Row className="justify-content-center px-5 py-4">
                  {group.map((noticia, cardIndex) => {
                    const animationVariant = cardIndex === 1 ? fadeMiddle : fadeDown;
                    return (
                      <Col key={noticia.id} md={4} sm={12} className="mb-4">
                        <motion.div
                          initial="hidden"
                          animate={inView ? "visible" : "hidden"}
                          transition={{ duration: 0.35, delay: 0.08 * cardIndex }}
                          variants={animationVariant}
                          style={{
                            ...styles.noticiaCard,
                            ...(hovered === noticia.id ? styles.noticiaCardHover : {}),
                          }}
                          onMouseEnter={() => setHovered(noticia.id)}
                          onMouseLeave={() => setHovered(null)}
                        >
                          <Link to={noticia.link} style={{ textDecoration: 'none' }}>
                            <Image
                              src={noticia.image}
                              fluid
                              style={styles.noticiaImage}
                            />
                            <div style={styles.noticiaLabel}>
                              <h5 style={styles.noticiaLabelH5}>{noticia.title}</h5>
                              <p style={styles.noticiaLabelP}>{noticia.subtitle}</p>
                            </div>
                          </Link>
                        </motion.div>
                      </Col>
                    );
                  })}
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </Container>
    </motion.section>
  );
}
